/**
 * Binds a method of an object to that object, so the method can be called as if it belongs to the object.
 *
 * @param instance The object instance.
 * @param key The key of the method to bind.
 *
 * @returns The bound method.
 */
export function bind<T, K extends keyof T>(instance: T, key: K): T[K] {
  const method = instance[key] as (...args: any[]) => T[K]
  return method.bind(instance) as T[K]
}
